document.addEventListener('DOMContentLoaded', function () {
  

  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-product-item');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGQuickBuyButton extends HTMLElement {
    connectedCallback() {
      this._handleClick = this._handleClick.bind(this);
      this.addEventListener('click', this._handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleClick);
    }

    _handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.classList.contains('yg-quick-buy-button--disabled') || this.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const card = this.closest('product-card');
      if (!card) return;

      const quickBuyArea = card.querySelector('.product-card__quick-buy');
      if (!quickBuyArea) return;

      // 根据当前视口判断使用移动端还是桌面端触发器
      const isMobile = window.matchMedia('(pointer: coarse)').matches;

      if (isMobile) {
        // 移动端：触发 .product-card__mobile-quick-buy-button
        const mobileBtn = quickBuyArea.querySelector('.product-card__mobile-quick-buy-button');
        if (mobileBtn) {
          mobileBtn.click();
          return;
        }
      }

      // 桌面端：触发 pointer-coarse:hidden 区域内的按钮
      const desktopArea = quickBuyArea.querySelector('.pointer-coarse\\:hidden');
      if (desktopArea) {
        const btn = desktopArea.querySelector('button, [type="submit"]');
        if (btn) {
          btn.click();
          return;
        }
      }

      // 兜底：直接找 quick-buy-drawer 并触发 open
      const drawer = quickBuyArea.querySelector('quick-buy-drawer');
      if (drawer) {
        const toggleBtn = quickBuyArea.querySelector('[aria-controls="' + drawer.id + '"]');
        if (toggleBtn) toggleBtn.click();
      }
    }
  }

  if (!window.customElements.get('yg-quick-buy-button')) {
    window.customElements.define('yg-quick-buy-button', YGQuickBuyButton);
  }

  class YGKeyFeatured extends HTMLElement {
    connectedCallback() {
      // 等待字体及布局稳定后再初始化
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => requestAnimationFrame(() => this.init()));
      } else {
        requestAnimationFrame(() => requestAnimationFrame(() => this.init()));
      }
    }

    init() {
      const content = this.querySelector('.yg-featured-content');
      const toggleBtn = this.querySelector('.yg-toggle-btn');
      const btnText = this.querySelector('.yg-btn-text');

      const collapseLines = parseInt(this.dataset.collapseLines, 10);

      // collapseLines 为 0 表示展示全部，不启用折叠
      if (collapseLines === 0) {
        content.style.setProperty('-webkit-line-clamp', 'unset');
        content.style.removeProperty('overflow');
        return;
      }

      const lines = collapseLines || 6;

      // 先测量完整内容的高度
      content.style.setProperty('-webkit-line-clamp', 'unset');
      content.style.setProperty('overflow', 'visible');
      const fullHeight = content.scrollHeight;

      // 再设置 line-clamp 并测量
      content.style.setProperty('-webkit-line-clamp', String(lines));
      content.style.setProperty('overflow', 'hidden');
      
      // 强制重排
      content.offsetHeight;
      
      // 比较 scrollHeight 和 clientHeight，如果 scrollHeight 更大说明内容被截断
      const hasOverflow = content.scrollHeight > content.clientHeight + 5;

      if (hasOverflow) {
        // 需要折叠
        content.style.setProperty('-webkit-line-clamp', String(lines));

        toggleBtn.removeAttribute('hidden');

        toggleBtn.addEventListener('click', () => {
          if (toggleBtn.classList.contains('active')) {
            toggleBtn.classList.remove('active');
            content.style.setProperty('-webkit-line-clamp', String(lines));
            btnText.innerText = 'See More';
          } else {
            toggleBtn.classList.add('active');
            content.style.setProperty('-webkit-line-clamp', 'unset');
            btnText.innerText = 'See Less';
          }
        });
      } else {
        // 内容不足设定行数，完全展开
        content.style.setProperty('-webkit-line-clamp', 'unset');
      }
    }
  }

  if (!window.customElements.get('yg-key-featured')) {
    window.customElements.define('yg-key-featured', YGKeyFeatured);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  class YGVariantInfoPicker extends HTMLElement {
    connectedCallback() {
      this._onChange = this._onChange.bind(this);
      this.addEventListener('change', this._onChange);
      this._syncSelected();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
    }

    _onChange(event) {
      const input = event.target;
      if (!input || input.type !== 'radio' || !input.matches('input[data-option-position]')) return;
      this._syncSelected();
    }

    _syncSelected() {
      this.querySelectorAll('.yg-variant-info-card').forEach((card) => card.classList.remove('is-selected'));
      this.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
        const label = this.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) label.classList.add('is-selected');
      });
    }
  }

  if (!window.customElements.get('yg-variant-info-picker')) {
    window.customElements.define('yg-variant-info-picker', YGVariantInfoPicker);
  }

  
  class YGBuyWith extends HTMLElement {
    connectedCallback() {
      this.cards = this.querySelectorAll('[data-buy-with-card]');
      this.onDocClick = this.handleDocClick.bind(this);
      document.addEventListener('click', this.onDocClick);

      this.cards.forEach((card) => {
        card.querySelector('[data-variant-toggle]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleVariantDropdown(card);
        });

        card.querySelectorAll('[data-variant-option]').forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.selectVariant(card, option);
          });
        });

        card.querySelector('[data-add-button]')?.addEventListener('click', async (event) => {
          event.preventDefault();
          await this.handleAddButton(event.currentTarget);
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }

    handleDocClick(event) {
      if (this.contains(event.target)) return;
      this.closeAllDropdowns();
    }

    toggleVariantDropdown(card) {
      const options = card.querySelector('[data-variant-options]');
      if (!options) return;

      const isOpen = options.classList.contains('is-open');
      this.closeAllDropdowns();

      if (!isOpen) {
        card.classList.add('is-open');
        options.classList.add('is-open');
      }
    }

    closeAllDropdowns() {
      this.cards.forEach((card) => {
        card.classList.remove('is-open');
        card.querySelector('[data-variant-options]')?.classList.remove('is-open');
      });
    }

    async handleAddButton(addButton) {
      if (!addButton) return;

      const payload = this.buildBundlePayload(addButton);
      if (!payload.variantId) return;

      const bundleApi = window.YGBundleBuilderBarV1External;

      try {
        if (bundleApi && typeof bundleApi.addAccessory === 'function') {
          await bundleApi.addAccessory(payload);
          return;
        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: Number(payload.variantId),
            quantity: Number(payload.quantity || 1),
          }),
        });
      } catch (_) {}
    }

    buildBundlePayload(addButton) {
      return {
        productId: addButton.dataset.bundleProductId || '',
        variantId: addButton.dataset.variantId || '',
        gid: addButton.dataset.gid || `gid://shopify/ProductVariant/${addButton.dataset.variantId || ''}`,
        title: addButton.dataset.title || '',
        image: addButton.dataset.image || '',
        price: addButton.dataset.price || '',
        compareAtPrice: addButton.dataset.compareAtPrice || addButton.dataset.price || '',
        available: addButton.dataset.available === 'true',
        quantity: Number(addButton.dataset.quantity || 1),
      };
    }

    syncAddButtonByVariant(addButton, option, productTitle) {
      if (!addButton || !option) return;

      const variantTitle = option.dataset.variantTitle || '';
      addButton.dataset.variantId = option.dataset.variantId || '';
      addButton.dataset.gid = option.dataset.variantGid || `gid://shopify/ProductVariant/${option.dataset.variantId || ''}`;
      addButton.dataset.price = option.dataset.variantPrice || '';
      addButton.dataset.compareAtPrice = option.dataset.variantCompareAtPrice || option.dataset.variantPrice || '';
      addButton.dataset.image = option.dataset.variantImage || '';
      addButton.dataset.available = option.dataset.variantAvailable || 'false';
      addButton.dataset.title = variantTitle && variantTitle !== 'Default Title' ? `${productTitle} - ${variantTitle}` : productTitle;
      addButton.disabled = option.dataset.variantAvailable !== 'true';
    }

    selectVariant(card, option) {
      const variantName = card.querySelector('[data-variant-name]');
      const priceWrap = card.querySelector('[data-product-price]');
      const addButton = card.querySelector('[data-add-button]');
      const links = card.querySelectorAll('[data-buy-with-link]');
      const titleLink = card.querySelector('.yg-buy-with__title-link');

      const variantTitle = option.dataset.variantTitle;
      const variantPriceHtml = option.dataset.variantPriceHtml;
      const variantUrl = option.dataset.variantUrl;

      card.querySelectorAll('[data-variant-option]').forEach((item) => item.classList.remove('is-selected'));
      option.classList.add('is-selected');

      if (variantName) variantName.textContent = variantTitle;
      if (priceWrap && variantPriceHtml) priceWrap.innerHTML = variantPriceHtml;

      links.forEach((link) => {
        link.setAttribute('href', variantUrl);
      });

      this.syncAddButtonByVariant(addButton, option, titleLink?.textContent?.trim() || '');

      this.closeAllDropdowns();
    }
  }

  if (!customElements.get('yg-buy-with')) {
    customElements.define('yg-buy-with', YGBuyWith);
  }

  (function() {
  function applyInboxStyles() {
    const inbox = document.querySelector('inbox-online-store-chat');

    if (!inbox || !inbox.shadowRoot) return;

    let style = inbox.shadowRoot.querySelector('#custom-chat-style');

    if (window.innerWidth <= 699) {
      if (!style) {
        style = document.createElement('style');
        style.id = 'custom-chat-style';

        style.textContent = `
          button.chat-toggle.chat-toggle--icon-button {
            width: 40px !important;
            height: 40px !important;
          }

          button.chat-toggle svg {
            height: 30px !important;
          }
        `;

        inbox.shadowRoot.appendChild(style);
      }
    } else {
      style?.remove();
    }
  }

  // 初始执行
  applyInboxStyles();

  // Shopify Inbox 异步加载
  const observer = new MutationObserver(() => {
    applyInboxStyles();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 页面宽度变化时重新判断
  window.addEventListener('resize', applyInboxStyles);
})();

chat.shadowRoot.appendChild(style);
})




